import React from 'react';

const Header = () => (
  <>
    <div className="progress-wrap cursor-pointer">
        <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
            <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
    </div>
    
    <nav className="navbar navbar-expand-lg">
        <div className="container">
           
            <div className="logo-wrapper">
                <a className="logo" href="/"> 
                  <img src="img/logo.png" className="logo-img" alt="logo" /> </a>
            </div>
         
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbar" aria-controls="navbar" aria-expanded="false" aria-label="Toggle navigation"> <span className="navbar-toggler-icon"><i className="ti-menu"></i></span> </button>
           
            <div className="collapse navbar-collapse" id="navbar">
                <ul className="navbar-nav ms-auto">
                  <li className="nav-item"><a className="nav-link" href='/'>Home</a> </li>
                  <li className="nav-item"><a className="nav-link" href='/about-us'>About Us</a> </li>
                  <li className="nav-item"><a className="nav-link" href='/hotels'>HOTELS</a> </li>
                  <li className="nav-item"><a className="nav-link" href='/events'>Events</a> </li>
                  <li className="nav-item"><a className="nav-link BookNow" href='/contact-us'>Contact us</a> </li>
                  
                </ul>
            </div>
        </div>
    </nav>
  </>
);

export default Header;